// Copyright (c) StrangeBee 2023

import React, { ReactElement, useContext } from 'react';
import { useLocalMessage } from '@Helpers/';
import DisplayDate from '@Atoms/Display/DisplayDate/DisplayDate';
import { useFormatDate } from '@Hooks/useFormatDate';
import moment from 'moment';
import { LanguageSwitcherContext } from '@Lang/LanguageSwitcherContext';
export interface FormatDateProps {
    date?: number;
    displayFrom?: boolean;
    onlyFrom?: boolean;
    defaultStyle?: boolean;
    icon?: boolean;
    label?: string;
    onClick?: (date: number) => void;
    className?: string;
    endDate?: number;
    withoutSuffix?: boolean;
}

const FormatDate = ({
    date = 0,
    displayFrom = false,
    onlyFrom = false,
    defaultStyle = false,
    icon = false,
    label = '',
    onClick,
    className = '',
    endDate,
    withoutSuffix = false,
}: FormatDateProps): ReactElement => {
    const i = useLocalMessage();
    const f = useFormatDate();
    const { language } = useContext(LanguageSwitcherContext);

    const momentFrom =
        endDate !== undefined
            ? moment(date).locale(language).from(endDate, withoutSuffix)
            : moment(date).locale(language).fromNow(withoutSuffix);

    if (onlyFrom) {
        return <>{`${label} ${momentFrom}`}</>;
    }

    return (
        <DisplayDate
            onClick={onClick}
            date={f(date)}
            timestamp={date}
            dateInvalidMessage={i('common.noDate')}
            defaultStyle={defaultStyle}
            fromDate={displayFrom ? momentFrom : ''}
            icon={icon}
            label={label}
            className={className}
        />
    );
};

export default FormatDate;
